import { HeaderAbout } from "./headerAbout";
import { MainAbout } from "./mainAbout";

export const AboutPage = () => {
  return (
    <>
      <HeaderAbout />
      <MainAbout />
    </>
  );
};
